import { useEffect, useRef } from 'react'

/**
 * Intervalo que não reinicia quando o callback muda de identidade.
 *
 * Passar uma função inline direto para setInterval dentro de um efeito faria o
 * timer ser recriado a cada render, e um intervalo de 30 segundos nunca
 * chegaria a disparar numa tela que atualiza com frequência.
 */
export function useInterval(callback: () => void, delayMs: number | null): void {
  const saved = useRef(callback)

  useEffect(() => {
    saved.current = callback
  }, [callback])

  useEffect(() => {
    if (delayMs === null) return
    const id = setInterval(() => saved.current(), delayMs)
    return () => clearInterval(id)
  }, [delayMs])
}
